import { useRef, useState } from 'react';

import { useChat } from '@/features/ai-chat/state/useChat';

export function useAskGXContent() {
  const { conversationId, setConversationId, messages } = useChat();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const historyBtnRef = useRef<HTMLElement | null>(null);

  const handleHistoryClick = () => {
    if (anchorEl) {
      setAnchorEl(null);
    } else if (historyBtnRef.current) {
      setAnchorEl(historyBtnRef.current);
    }
  };

  return {
    conversationId,
    setConversationId,
    messages,
    anchorEl,
    setAnchorEl,
    historyBtnRef,
    handleHistoryClick
  } as const;
}
